module.exports = __webpack_public_path__ + "img/contact.44efd932.jpg";